import { SeasonIcon, Text } from '@wyz/ui';
import * as React from 'react';
import { Trans } from '~/common/context';
import { DistributionPricingPolicyHelpers } from '~/purchase/helpers';
import { IDistributionPricingPolicySeason } from '~/purchase/types';

const { seasonClass } = DistributionPricingPolicyHelpers;

type Props = {
  seasons: IDistributionPricingPolicySeason[];
  canSeeExtraBonus: boolean;
  metricCount: number;
};

export function ExtraBonusTableHead({
  seasons,
  canSeeExtraBonus,
  metricCount,
}: Props) {
  return (
    <thead>
      <tr>
        <th className='extra-bonus-table__lead' rowSpan={2}>
          <Text
            color='secondary-gray'
            heading='normal'
            weight='semi-bold'
            className='text-uppercase'
          >
            <Trans i18nKey='app.distribution.pricing_policy.detail.column.brand_supplier' />
          </Text>
        </th>
        {canSeeExtraBonus && (
          <th
            className='extra-bonus-table__lead extra-bonus-table__lead--hq'
            rowSpan={2}
          >
            <Text color='secondary-gray' heading='normal' weight='semi-bold'>
              <Trans i18nKey='app.distribution.pricing_policy.detail.column.bonus_hq' />
            </Text>
          </th>
        )}
        {seasons.map((season) => (
          <th
            key={season.id}
            colSpan={metricCount}
            className={`extra-bonus-table__season extra-bonus-table__season--title${seasonClass(season)}`}
          >
            <span className='extra-bonus-table__season-icon'>
              <SeasonIcon value={season.id} size='xs' />{' '}
            </span>
            <span className='text-uppercase'>
              <Trans i18nKey={season.i18nKey} />
            </span>
          </th>
        ))}
      </tr>

      <tr>
        {seasons.map((season) => (
          <React.Fragment key={season.id}>
            <th
              className={`extra-bonus-table__season extra-bonus-table__season--metric${seasonClass(season)}`}
            >
              <Trans i18nKey='app.distribution.pricing_policy.detail.column.purchase' />
            </th>
            {canSeeExtraBonus && (
              <>
                <th
                  className={`extra-bonus-table__season extra-bonus-table__season--metric${seasonClass(season)}`}
                >
                  <Trans i18nKey='app.distribution.pricing_policy.detail.column.extra_bonus' />
                </th>
                <th
                  className={`extra-bonus-table__season extra-bonus-table__season--metric${seasonClass(season)}`}
                >
                  <Trans i18nKey='app.distribution.pricing_policy.detail.column.total' />
                </th>
              </>
            )}
          </React.Fragment>
        ))}
      </tr>
    </thead>
  );
}
